import { useEffect } from 'preact/compat'
import { useDispatch } from 'react-redux'
import { pageStateUpdate } from '../redux/slice/pageStateSlice'

export default function usePaymentBlocked(isPaymentBlocked) {
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(pageStateUpdate({ isPaymentBlocked: isPaymentBlocked === 'true' }))
  }, [isPaymentBlocked])
}
